<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-calendar"></i> 报表管理
        </el-breadcrumb-item>
        <el-breadcrumb-item>包装关联</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="handle-box">
        <el-form ref="searchform" :model="searchform" label-width="80px" @keyup.enter.native="search()">
          <el-row>
            <el-col :span="6">
              <el-form-item label="订单" prop="orderNo">
                <el-input v-model="searchform.orderNo" style="width:100%" clearable placeholder="请输入订单" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="批次号" prop="batchno">
                <el-input v-model="searchform.batchno" style="width:100%" clearable placeholder="请输入批次号" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="子级码" prop="qrcode">
                <el-input v-model="searchform.qrcode" style="width:100%" clearable placeholder="请输入子级码" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="父级码" prop="qrcode_parent">
                <el-input v-model="searchform.qrcode_parent" style="width:100%" clearable placeholder="请输入父级码" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="产品编码" prop="productCode">
                <el-select style="width:100%" v-model="searchform.productCode" clearable filterable remote
                  placeholder="请输入产品名称或编码模糊匹配" :remote-method="getProductSelectList" :loading="productSelectLoading">
                  <el-option v-for="item in productSelectList" :key="item.product_code" :label="item.product"
                    :value="item.product_code" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item v-if="enableSubOrder" label="子加工单" clearable prop="subtaskOrder">
                <el-input v-model="searchform.subtaskOrder" type="text" placeholder="请输入子加工单" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="包装级别" prop="level">
                <el-select v-model="searchform.level" placeholder="请选择包装级别">
                  <el-option v-for="item in levellist" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8" :offset="1">
              <el-button @click="resetForm('searchform')">重置</el-button>
              <el-button type="primary" icon="el-icon-search" @click="search"
                v-permission="['relevance_select']">搜索</el-button>
              <!-- <el-button
                v-permission="['relevance_export']"
                :loading="downloadLoading"
                type="primary"
                icon="document"
                @click="handleDownload"
              >导出Excel</el-button> -->
            </el-col>
          </el-row>
        </el-form>
        <br />
      </div>

      <el-row type="flex" class="row-bg">
        <el-col :span="24" class="border">
          <h4>包装关联查询</h4>
          <el-divider></el-divider>
          <el-table border v-loading="tableLoading" element-loading-text="拼命加载中" :data="tableData" style="width:100%;"
            id="parent">
            <af-table-column prop="orderno" label="订单" min-width="100" show-overflow-tooltip></af-table-column>
            <af-table-column prop="batchno" label="批次号" min-width="100" show-overflow-tooltip></af-table-column>
            <af-table-column prop="factory" label="工厂" min-width="120" show-overflow-tooltip></af-table-column>
            <af-table-column v-if="enableSubOrder" prop="subtask_order" label="子加工单" min-width="120"
              show-overflow-tooltip></af-table-column>
            <af-table-column prop="child_num" label="子级生产数量" min-width="120" show-overflow-tooltip></af-table-column>
            <af-table-column prop="child_num_relation" label="子级采集数量" min-width="120"
              show-overflow-tooltip></af-table-column>
            <af-table-column prop="product_code" label="产品编码" min-width="200" show-overflow-tooltip></af-table-column>
            <af-table-column prop="product_name" label="产品名称" min-width="200" show-overflow-tooltip></af-table-column>
            <af-table-column prop="specs" label="规格" min-width="120" show-overflow-tooltip></af-table-column>
            <af-table-column prop="qrcode" label="子级码" min-width="100" show-overflow-tooltip></af-table-column>
            <af-table-column prop="qrcode_parent" label="父级码" min-width="100" show-overflow-tooltip></af-table-column>
            <af-table-column prop="create_time" label="生产时间" min-width="100" show-overflow-tooltip>
              <template slot-scope="scope">{{ $parseTime(scope.row.create_time) }}</template>
            </af-table-column>
          </el-table>
          <br />
          <el-pagination background layout="total,prev, pager, next, jumper, sizes" :total="pageTotal"
            :page-sizes="[10, 20, 50, 100]" :page-size.sync="searchform.pageSize"
            :current-page.sync="searchform.pageIndex" @size-change="handleSizeChange"
            @current-change="handleCurrentChange" />
        </el-col>
      </el-row>
    </div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <h4>备注：</h4>
      </div>
      <span>输入盒码关联箱码，输入箱码关联盒码</span>
    </el-card>
  </div>
</template>
<script>
import { packquery } from "@/api/plant";
import { productlist } from "@/api/base";
import store from "@/store";
export default {
  data() {
    return {
      enableSubOrder: store.state.user.enable_sub_order,
      //表格数据
      tableLoading: false,
      tableData: [],
      //产品下拉选择列表
      productSelectLoading: false,
      productSelectList: [],
      //分页数据
      pageTotal: 0,
      //搜索表单数据
      searchform: {
        orderNo: null,
        batchno: null,
        qrcode: null,
        qrcode_parent: null,
        productCode: null,
        subtaskOrder: null,
        level: 1,
        pageSize: 10,
        pageIndex: 1,
      },
      //包装级别
      levellist: [
        {
          value: 1,
          label: "一级包装-二级包装"
        },
        {
          value: 2,
          label: "二级包装-三级包装"
        },
        {
          value: 3,
          label: "三级包装-四级包装"
        }, 
        {
          value:4,
          label:"四级包装-五级包装"
        }
      ],
    };
  },
  mounted() {
    this.getProductSelectList();
  },
  methods: {
    // 获取产品下拉列表
    getProductSelectList(value) {
      if (value !== "") {
        this.productSelectLoading = true;
        setTimeout(() => {
          this.productSelectLoading = false;
          productlist({ productName: value }).then(response => {
            this.productSelectList = response.data.data || [];
            for (var item of this.productSelectList) {
              item.product = item.product_code + " - " + item.product_name;
            }
          });
        }, 200);
      } else {
        this.productSelectList = [];
      }
    },
    //请求表格数据
    fetchTableData() {
      if (!this.validateSearch()) {
        return;
      }
      this.tableLoading = true;
      packquery(this.searchform).then(response => {
        this.tableData = response.data.data;
        this.packdate(this.tableData);
        this.pageTotal = response.data.total_count;
      }).finally(() => {
        this.tableLoading = false;
      });
    },
    packdate(data) {
      data.forEach(item => {
        item.factory = (item.factory_code || "") + (item.factory_name || "");
      });
    },
    //重置按钮
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.tableData = [];
      this.pageTotal = 0;
      this.searchform.pageIndex = 1;
      this.searchform.pageSize = 10;
      this.getProductSelectList();
    },
    //搜索事件
    search() {
      if (!this.validateSearch()) {
        this.$message({
          message: "请输入搜索条件",
          type: "warning"
        });
        return;
      }
      this.searchform.pageIndex = 1;
      this.fetchTableData();
    },
    //分页跳转事件
    handleCurrentChange(val) {
      this.fetchTableData();
    },
    //分页每页显示条数事件
    handleSizeChange(val) {
      this.fetchTableData();
    },
    //校验搜索条件
    validateSearch() {
      return this.searchform.qrcode_parent || this.searchform.batchno || this.searchform.productCode || this.searchform.orderNo
        || this.searchform.qrcode || this.searchform.subtaskOrder;
    },
  }
};
</script>
<style scoped></style>